import { useToastStore } from '../stores/toast';

export function useToast() {
  const toastStore = useToastStore();

  function success(message: string, duration?: number) {
    return toastStore.addToast({ type: 'success', message, duration });
  }

  function error(message: string, duration?: number) {
    return toastStore.addToast({ type: 'error', message, duration });
  }

  function warning(message: string, duration?: number) {
    return toastStore.addToast({ type: 'warning', message, duration });
  }

  function info(message: string, duration?: number) {
    return toastStore.addToast({ type: 'info', message, duration });
  }

  return {
    success,
    error,
    warning,
    info,
  };
}
